const languagesDone = [
    {
        name: 'C++',
        percentDone: 90
    },
    {
        name: 'Python',
        percentDone: 70
    },
    {
        name: 'React Js',
        percentDone: 80
    },
    {
        name: 'Node Js',
        percentDone: 70
    },
    {
        name: 'Dart',
        percentDone:40
    }
]
const EducationData={
    collegeName:"Rajkiya Engineering College, Ambedkar Nagar",
    courseName:"B.Tech in Information Technology",
    couseStartYear:"2021",
    courseEndYear:"Present",
    details:[
        'I joined my college in 2021. Cleared First and Second Year with a good academic performance.',
        'I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, COA, AI etc.',
        ' Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.'
    ],
    codingStatus:languagesDone
}
export default EducationData;